const features = [
  "入れ歯の種別に関わらず一律料金",
  "保証期間付き（詳しくはお問い合わせ）",
  "当日お渡しの即日対応",
];

export default function PricingSection() {
  return (
    <section id="pricing" className="py-24 bg-stone-50">
      <div className="max-w-5xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-16">
          <span className="inline-block text-teal-700 text-sm font-semibold tracking-widest uppercase mb-3">Pricing</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            料金のご案内
          </h2>
          <div className="w-12 h-0.5 bg-amber-500 mx-auto mb-6" />
          <p className="text-gray-600 text-base max-w-lg mx-auto">
            入れ歯の種別に関わらず明瞭会計。<br />
            上下セットはお得な割引価格でご提供します。
          </p>
        </div>

        {/* Pricing cards */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Card 1 */}
          <div className="bg-white rounded-xl border border-gray-200 p-8 flex flex-col">
            <div className="mb-6">
              <span className="inline-block bg-teal-50 text-teal-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">片顎（上または下）</span>
              <h3 className="text-xl font-bold text-gray-900 mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                入れ歯 1床
              </h3>
              <p className="text-gray-500 text-sm">上顎または下顎、1床分の入れ歯製作</p>
            </div>
            <div className="mb-6">
              <span className="text-4xl font-bold text-gray-900">330,000</span>
              <span className="text-gray-600 text-base ml-1">円</span>
              <span className="block text-sm text-gray-400 mt-1">税込</span>
            </div>
            <ul className="space-y-3 mb-8 flex-1">
              {features.map((f) => (
                <li key={f} className="flex items-start gap-3 text-sm text-gray-600">
                  <i className="ri-check-line text-teal-600 mt-0.5 flex-shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
            <a
              href="https://pro.form-mailer.jp/fms/e40aa43b232020"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap cursor-pointer block text-center bg-teal-700 hover:bg-teal-800 text-white font-semibold py-3 rounded-md transition-colors"
            >
              このプランで申し込む
            </a>
          </div>

          {/* Card 2 – Featured */}
          <div className="bg-teal-700 rounded-xl p-8 flex flex-col relative overflow-hidden">
            <div className="absolute top-0 right-0 bg-amber-500 text-white text-xs font-bold px-4 py-1.5 rounded-bl-lg tracking-wide">
              おすすめ
            </div>
            <div className="mb-6">
              <span className="inline-block bg-white/20 text-white text-xs font-semibold px-3 py-1 rounded-full mb-4">上下セット</span>
              <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                入れ歯 上下セット
              </h3>
              <p className="text-white/70 text-sm">上顎・下顎2床分の入れ歯をセットで製作</p>
            </div>
            <div className="mb-2">
              <span className="text-white/60 text-sm line-through">660,000円</span>
            </div>
            <div className="mb-6">
              <span className="text-4xl font-bold text-white">550,000</span>
              <span className="text-white/80 text-base ml-1">円</span>
              <span className="block text-sm text-white/60 mt-1">税込 ／ 110,000円お得！</span>
            </div>
            <ul className="space-y-3 mb-8 flex-1">
              {[...features, "上下同時製作で一日で完結"].map((f) => (
                <li key={f} className="flex items-start gap-3 text-sm text-white/85">
                  <i className="ri-check-line text-amber-400 mt-0.5 flex-shrink-0" />
                  {f}
                </li>
              ))}
            </ul>
            <a
              href="https://pro.form-mailer.jp/fms/e40aa43b232020"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap cursor-pointer block text-center bg-amber-500 hover:bg-amber-600 text-white font-bold py-3 rounded-md transition-colors"
            >
              このプランで申し込む
            </a>
          </div>
        </div>

        {/* Adjustment Fee */}
        <div className="bg-white rounded-xl border border-gray-200 p-6 mb-6 flex flex-col sm:flex-row items-start sm:items-center gap-5">
          <div className="w-12 h-12 flex items-center justify-center flex-shrink-0 bg-teal-50 rounded-lg">
            <i className="ri-tools-line text-teal-700 text-xl" />
          </div>
          <div className="flex-1">
            <p className="text-xs font-semibold text-teal-700 tracking-wider uppercase mb-1">Adjustment Fee</p>
            <h4 className="text-base font-bold text-gray-900 mb-1" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              入れ歯調整費用
            </h4>
            <p className="text-sm text-gray-500 leading-relaxed">
              製作後、口腔内のフィット感を整えるための調整を行う場合、<strong className="text-gray-700">1回につき5,500円（税込）</strong>が別途かかります。調整は何度でも承ります。
            </p>
          </div>
          <div className="flex-shrink-0 text-right">
            <span className="text-3xl font-bold text-gray-900">5,500</span>
            <span className="text-gray-600 text-sm ml-1">円</span>
            <p className="text-xs text-gray-400 mt-0.5">税込 ／ 1回あたり</p>
          </div>
        </div>

        {/* Note */}
        <div className="bg-amber-50 border border-amber-200 rounded-lg px-6 py-4 text-sm text-amber-800">
          <p className="flex items-start gap-2 mb-1">
            <i className="ri-information-line mt-0.5 flex-shrink-0" />
            <span>製作料金はすべて税込価格です。入れ歯の種類・素材に関わらず一律料金です。</span>
          </p>
          <p className="flex items-start gap-2 text-amber-700">
            <i className="ri-arrow-right-s-line mt-0.5 flex-shrink-0" />
            <span>製作料とは別に、<strong>入れ歯の調整は1回につき5,500円（税込）</strong>が必要です。</span>
          </p>
        </div>
      </div>
    </section>
  );
}
